type NewResult = {
  resultCode: '0' | '200'
  detailMsg: any
  subMsg: {
    bCode: string
    bMsg: string
  }
}
type OldResult = {
  code: '0'
  result: any
  businessMsg: {
    businessCode: string
    businessNote: string
  }
}
/**
 * 兼容旧的response 结构体
 * @param result
 * @returns
 */
export const transformResponse = (data: string) => {
  const result: NewResult & OldResult = JSON.parse(data)

  if (Reflect.has(result, 'resultCode'))
    return {
      resultCode: result.resultCode,
      result: result.detailMsg,
      errMsg: {
        code: result?.businessMsg?.businessCode || '',
        note: result?.businessMsg?.businessNote || '',
      },
    }

  const oldCodeMap = {
    0: '200',
  }
  return {
    resultCode: oldCodeMap[result.code] ? oldCodeMap[result.code] : result.code,
    result: result.result,
    errMsg: {
      code: result?.subMsg?.bCode || Number(result.subMsg.bCode),
      note: result?.subMsg?.bMsg,
    },
  }
}
